module.exports = __webpack_public_path__ + "static/media/sidebar_bg.ed7c3836.jpg";